import type { DecimalInput } from '@app/shared';
import { formatMoney } from '@/shared/lib/money';

export interface MoneyProps {
  value: DecimalInput;
  currency?: string;
  className?: string;
}

/** Formats a Decimal-compatible amount for display — never do further math on the result. */
export function Money({ value, currency, className }: MoneyProps) {
  return (
    <span className={className ? `tabular-nums ${className}` : 'tabular-nums'}>
      {formatMoney(value, currency)}
    </span>
  );
}
